import React from "react"
import { Table, TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { IExpenseDocument, IExpensesPayrollData, IObjectAudit } from "../../models"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import * as utils from "../../helpers/utils"
import * as timeHelper from "../../helpers/timeHelper"
import moment from "moment"
import { green500, grey500, red500 } from "material-ui/styles/colors"
import ApprovedIcon from "./ApprovedIcon"
import * as fileActions from "../../actions/FileActions"
import AccountStore from "../../stores/AccountStore"

interface IProps {
    readonly?: boolean
    nonSelectable?: boolean
    hideCheckBox?: boolean
    showExported: boolean
    expenses: (IExpenseDocument | IExpensesPayrollData)[]
    selectedExpenses?: (IExpenseDocument | IExpensesPayrollData)[]
    handleUpdate?(expense: IExpenseDocument | IExpensesPayrollData): void
    handleSelect?(expenses: (IExpenseDocument | IExpensesPayrollData)[]): void
    onExpensePayrollFileDownload?(expenseId: string): void
}

interface IState {
    selectedExpenses: (IExpenseDocument | IExpensesPayrollData)[]
    showTable: boolean
}

export default class UserDetailExpensesTable extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            selectedExpenses: [],
            showTable: true,
        }
        autobind(this)
    }

    handelOnCellClick(rowNumber, colId) {
        if (this.props.readonly) return
        const clickedExpense = this.props.expenses[rowNumber]
        if (colId === -1) {
            if (this.props.nonSelectable) return
            let selectedExpenses = this.state.selectedExpenses.slice()
            if (this.state.selectedExpenses.find(item => item.Id === clickedExpense.Id)) {
                selectedExpenses = selectedExpenses.filter(item => item.Id !== clickedExpense.Id)
            }
            else {
                selectedExpenses.push(clickedExpense)
            }
            this.setSelectedExpenses(selectedExpenses)
        }
        else {
            this.props.handleUpdate &&
                this.props.handleUpdate(clickedExpense)
        }
    }

    handleOnRowSelection(result) {
        result === "all" && this.setSelectedExpenses(this.props.expenses.slice())
        result === "none" && this.setSelectedExpenses([])
    }

    setSelectedExpenses(selectedExpenses) {
        this.setState({ selectedExpenses, showTable: false }, () => this.setState({ showTable: true }))
        this.props.handleSelect &&
            this.props.handleSelect(selectedExpenses)
    }

    downloadExpensePayrollFile(expenseId: string){
        this.props.onExpensePayrollFileDownload(expenseId)
    }

    render() {
        const showCheckBoxes = this.props.hideCheckBox ? false : true
        return (
            <Table
                allRowsSelected={this.props.expenses.length === this.state.selectedExpenses.length}
                multiSelectable={!this.props.readonly && !this.props.nonSelectable}
                selectable={!this.props.readonly && !this.props.nonSelectable}
                onCellClick={this.handelOnCellClick}
                onRowSelection={this.handleOnRowSelection}
                style={{ backgroundColor: "none" }}
            >
                <TableHeader
                    displaySelectAll={showCheckBoxes}
                    adjustForCheckbox={showCheckBoxes}
                >
                    <TableRow>
                        <TableHeaderColumn style={styles.headerCol}>{strings.Name}</TableHeaderColumn>
                        <TableHeaderColumn style={{ ...styles.headerCol, textAlign: "center" }}>{strings.Taxable}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>{strings.Hours}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>{strings.Amount}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>{strings.Total_Paid}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>{strings.Date}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>{strings.Pay_Type}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>{strings.HierarchyLevel}</TableHeaderColumn>
                        <TableHeaderColumn style={{ ...styles.headerCol, textAlign: "center" }}>{strings.EMP_Approved}</TableHeaderColumn>
                        <TableHeaderColumn style={{ ...styles.headerCol, textAlign: "center" }}>{strings.Sup_Approved}</TableHeaderColumn>
                        <TableHeaderColumn style={{ ...styles.headerCol, textAlign: "center" }}>{strings.Receipt}</TableHeaderColumn>
                        {this.props.showExported &&
                            <TableHeaderColumn style={{ ...styles.headerCol, textAlign: "center" }}>{strings.Exported}</TableHeaderColumn>
                        }
                    </TableRow>
                </TableHeader>
                <TableBody showRowHover={true} deselectOnClickaway={false} displayRowCheckbox={showCheckBoxes}>
                    {this.props.expenses.map((row, index) => {
                        const payTypeName = payGroupAndTypeHelper.getPayTypeNameById(row.PayTypeId)
                        return (
                            <TableRow
                                data-intercom-target={index === 0 && "Expenses-openExpenseDetails"}
                                key={index}
                                selected={this.state.selectedExpenses.find(item => item.Id === row.Id) ? true : false}
                            >
                                <TableRowColumn style={styles.rowCol}>{row.Name}</TableRowColumn>
                                <TableRowColumn style={{ ...styles.rowCol, textAlign: "center" }}>
                                    {row.Taxable &&
                                        <i style={{ fontSize: 22, color: green500 }} className="fa fa-check" />
                                    }
                                </TableRowColumn>
                                <TableRowColumn style={styles.rowCol}>{row.IsTime && row.Amount}</TableRowColumn>
                                <TableRowColumn style={styles.rowCol}>{!row.IsTime && utils.getCurrencyFormat(row.Amount)}</TableRowColumn>
                                <TableRowColumn style={styles.rowCol}>
                                    {utils.getCurrencyFormat(row.IsTime ?
                                        (row.Classification && row.Classification.PayAmount) ?
                                            row.Classification.PayAmount :
                                            0 :
                                        row.Amount
                                    )}
                                </TableRowColumn>
                                <TableRowColumn style={styles.rowCol}>{moment(timeHelper.keepConvertUTCToLocal(row.PayDate)).format("MM/DD/YYYY")}</TableRowColumn>
                                <TableRowColumn style={{ ...styles.rowCol, color: payTypeName === strings.invalid && red500 }}>
                                    {payTypeName}
                                </TableRowColumn>
                                <TableRowColumn style={styles.rowCol}>
                                    {(row.Classification ? (row.Classification.HierarchyName ? row.Classification.HierarchyName : AccountStore.getCurrentAccount().Name) : AccountStore.getCurrentAccount().Name)}
                                </TableRowColumn>
                                <TableRowColumn style={{ ...styles.rowCol, textAlign: "center" }}>
                                    {row.EmployeeApproved &&
                                        <ApprovedIcon
                                            keyStr={`employee_${row.Id}`}
                                            label={strings.Employee_Approved}
                                            audit={row.EmployeeApprovalAudit}
                                        />
                                    }
                                </TableRowColumn>
                                <TableRowColumn style={{ ...styles.rowCol, textAlign: "center" }}>
                                    {row.SupervisorApproved &&
                                        <ApprovedIcon
                                            keyStr={`supervisor_${row.Id}`}
                                            label={strings.Supervisor_Approved}
                                            audit={row.SupervisorApprovalAudit}
                                        />
                                    }
                                </TableRowColumn>
                                <TableRowColumn style={{ ...styles.rowCol, textAlign: "center" }}>
                                    {row.ReceiptFileId &&
                                        <i
                                            className="fa fa-file-picture-o"
                                            style={{ fontSize: 22, color: grey500 }}
                                            onClick={e => {
                                                e.stopPropagation()
                                                fileActions.downloadFileWithId(row.ReceiptFileId)
                                            }}
                                        />
                                    }
                                </TableRowColumn>
                                {this.props.showExported &&
                                    <TableRowColumn style={{ ...styles.rowCol, textAlign: "center" }}>
                                        {row.PayrollExport && row.PayrollExport.Exported &&
                                            <ApprovedIcon
                                                keyStr={`employee_${row.Id}`}
                                                label={strings.Exported}
                                                audit={{
                                                    LastModified: row.PayrollExport.ExportDate,
                                                    LastModifiedByName: row.PayrollExport.ExportedByUserName
                                                } as IObjectAudit}
                                                fileId={row.PayrollExport.S3FileId}
                                                fileName={row.PayrollExport.S3FileName}
                                                onFileDownload={()=> {
                                                    this.downloadExpensePayrollFile(row.Id)
                                                }}
                                            />
                                        }
                                    </TableRowColumn>          
                                }                      
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        )
    }
}

const styles = {
    headerCol: {
        paddingLeft: 5,
        paddingRight: 5,
    },
    rowCol: {
        paddingLeft: 5,
        paddingRight: 5,
        cursor: "pointer"
    }
}
